import api from 'Application/api/api';

const editComment = async (signal, values) => {
	const response = await api.put('/step-comments', values, {
		signal,
		timeout: 100000,
	});

	if (!response || !response.data) {
		return response;
	}

	return {
		...response,
		data: response.data,
	};
};

export default editComment;
